import React, { Component } from 'react';

class CookieBanner extends Component {
    constructor(props) {
        super(props);
        this.state = { bannerVisible: false }
    }

    componentDidMount() {
        if (!window.localStorage.getItem('privacyBannerClosed')) {
            this.setState({bannerVisible: true});
        }
    }

    closeBanner() {
        window.localStorage.setItem('privacyBannerClosed', 'true');
        this.setState({bannerVisible: false});
    }

    render() {
        if (this.state.bannerVisible) {
            return (
                    <div className="cookieContainer" id="cookieContainer">
                        <div className="cookieBanner">
                            <div className="title">We don't use cookies. Enjoy your <a href="/privacy">privacy</a>.</div>
                            <button className="btnClose" onClick={() => this.closeBanner()}>Close</button>
                        </div>
                    </div>
            );
        }
        else {
            return false;
        }
    }
}

export default CookieBanner;
